import DashboardTeacher from "../../../../../components/categories/siakad/laporan_adab/beranda/HomeTeacher";
export default function Home() {
  
  return (
    <DashboardTeacher />
  );
}
